export interface PhotoDetail {
  id: string;
  albumId: string;
  albumTitle?: string;
  image: string;
  originalUrl?: string;
  downloadUrl?: string;
  caption: string;
  shotDate: string;
  uploadDate: string;
  uploaderName: string;
  uploaderEmail: string;
  originalFilename: string;
  fileSize: number;
  width: number;
  height: number;
  fileType: string;
  mediaType?: 'photo' | 'video';
  durationSeconds?: number;
  isFavorite?: boolean;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatResolution(width: number, height: number): string {
  return `${width} × ${height}`;
}
